export const getPrice = (price, hex, rand, decimal) => {
  return (Number(price) + Number(rand / hex)).toFixed(Number(decimal));
}
export const getMarginPrice = (price, hex, rand, decimal) => {
  return ((Number(price)*hex + Number(rand))/10000).toFixed(2);
}
/**
 * 
 * data 所有数据
 * 订单 code
 * amount 数量
 * multiple 杠杆
 */
export const cale_money = (data, code, amount, multiple, contract_type, start_leverage) => {
  let coin = data.find(item => item.code == code);
  let rand = coin.contract_rand;
  let hex = Number(coin.hex);
  let decimal = Number(coin.decimal);
  let res = {
    price: coin.price,
    up_price: getPrice(coin.price, hex, rand[1], decimal),
    down_price: getPrice(coin.price, hex, rand[0], decimal),
  }
  res['up_leverage_price'] = res.up_price * hex * amount * Number(multiple) * 0.01;
  res['down_leverage_price'] = res.down_price * hex * amount * Number(multiple) * 0.01;
  res['income'] = contract_type == 'up' ? (res.down_leverage_price - Number(start_leverage)).toFixed(2) : (Number(start_leverage) - res.up_leverage_price).toFixed(2);
  return res;
}



export const getMoneys = (data) => {
  const moneys = data.reduce((accumulator, currentValue) => {
    return accumulator + Number(currentValue.money)
  }, 0)
  return moneys.toFixed(2)
}